import React from "react";

import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";

import {
  IndividualRuleSchema,
  PublishingDaysExceptionSchema,
} from "../../types";
import { GAP, GRID_FOUR_COLUMNS } from "../../utils";

import PublicationDateRow from "./PublicationDateRow";

export interface ExclusionsSectionProps {
  rule: IndividualRuleSchema | undefined;
  isEditing: boolean;
  onRuleChange: (newRule: IndividualRuleSchema) => void;
  gap?: number;
  gridTemplateColumns?: string;
}

const ExclusionsSection: React.FC<ExclusionsSectionProps> = ({
  rule,
  isEditing,
  onRuleChange,
}) => {
  const handleAddExclusion = () => {
    if (rule == null) return;
    const newRule = {
      ...rule,
      exclusions: [...rule.exclusions, { day_name: "", date: "" }],
    };
    onRuleChange(newRule);
  };

  const handleDeleteExclusion = (index: number) => {
    if (rule == null) return;
    const newExclusions = [...rule.exclusions];
    newExclusions.splice(index, 1);
    onRuleChange({
      ...rule,
      exclusions: newExclusions,
    });
  };

  const handleUpdateExclusion = (
    index: number,
    newDate: PublishingDaysExceptionSchema,
  ) => {
    if (rule == null) return;
    const newExclusions = [...rule.exclusions];
    newExclusions[index] = newDate;
    onRuleChange({
      ...rule,
      exclusions: newExclusions,
    });
  };

  return (
    <Box id="excluded-dates">
      <Typography gutterBottom color="text.secondary" variant="subtitle2">
        Exkluderade utgivningsdagar
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: GRID_FOUR_COLUMNS,
          gap: GAP / 2,
        }}
      >
        {rule?.exclusions.map((date, index) => (
          <PublicationDateRow
            key={date.date}
            initialDate={date}
            isEditing={isEditing}
            onDelete={() => handleDeleteExclusion(index)}
            onUpdate={(newDate) => handleUpdateExclusion(index, newDate)}
          />
        ))}
        {!isEditing && rule?.exclusions.length === 0 && (
          <Typography color="text.secondary" variant="body2">
            Inga exkluderade utgivningsdagar.
          </Typography>
        )}
        {isEditing && (
          <Box>
            <Button startIcon={<Add />} onClick={handleAddExclusion}>
              Lägg till
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ExclusionsSection;
